import { z } from 'zod'

export const ContributionBenefitTypeEnum = {
  HEALTH: 100,
  ICHRA: 110,
  DENTAL: 200,
  VISION: 300,
  BASIC_LIFE: 400,
  SHORT_TERM_DISABILITY: 500,
  LONG_TERM_DISABILITY: 600,
  VOLUNTARY_SHORT_TERM_DISABILITY: 700,
  VOLUNTARY_LONG_TERM_DISABILITY: 800,
  VOLUNTARY_AD_D: 900,
  VOLUNTARY_LIFE: 1000,
  VOLUNTARY_LIFE_SIMPLE: 1100,
  LPFSA: 1200,
  LEGAL_SHIELD: 1300,
  LEGAL_PLAN: 1400,
  HSA: 1500,
  FTA: 1600,
  FSA: 1700,
  EMPLOYEE_ASSISTANCE: 1800,
  CHIROPRACTIC: 1900,
  INTERESTED: 10000,
  GROUP_HEALTH: 11000,
  DCFSA: 12000,
  ACCIDENT: 13000,
  HOSPITAL_INDEMNITY: 14000,
} as const
export const ContributionBenefitTypeSchemas = z.nativeEnum(
  ContributionBenefitTypeEnum
)
export type ContributionBenefitType = z.infer<
  typeof ContributionBenefitTypeSchemas
>

export const ContributionClassEnum = {
  DEFAULT: 10,
  CLASS_1: 20,
  CLASS_2: 30,
  CLASS_3: 40,
  CLASS_4: 50,
  CLASS_5: 60,
  FULL_TIME_SALARIED_EXEMPT: 100,
  FULL_TIME_SALARIED_NON_EXEMPT: 110,
  FULL_TIME_HOURLY_NON_EXEMPT: 120,
  PART_TIME_HOURLY_NON_EXEMPT: 130,
  NO_CONTRIBUTION: 140,
  TEMPORARY: 150,
  UNION_EMPLOYEE: 160,
  EE_SPOUSE: 200,
  EE_CHILD: 210,
  EE_FAMILY: 220,
  EE_SP_CH: 230,
  EE_SP_2_CH: 240,
  EE_SP_3_CH: 250,
  INCOME_TIER_1: 400,
  INCOME_TIER_2: 410,
  INCOME_TIER_3: 420,
  SALARIED: 501,
  CORPORATE: 600,
} as const
export const ContributionClassSchemas = z.nativeEnum(ContributionClassEnum)
export type ContributionClass = z.infer<typeof ContributionClassSchemas>

export const ContributionRelationshipEnum = {
  EMPLOYEE: '10',
  SPOUSE: '20',
  CHILD: '30',
  ADULT_CHILD: '40',
  DOMESTIC_PARTNER: '50',
  CHILD_OF_DOMESTIC_PARTNER: '60',
} as const
export const ContributionRelationshipSchema = z.nativeEnum(
  ContributionRelationshipEnum
)
export type ContributionRelationship = z.infer<
  typeof ContributionRelationshipSchema
>

export const EmploymentEnum = {
  EXEMPT: 10,
  NON_EXEMPT: 20,
  PART_TIME: 30,
} as const
export const EmploymentSchema = z.nativeEnum(EmploymentEnum)
export type EmploymentType = z.infer<typeof EmploymentSchema>

export const PersonRelationshipEnum = {
  EMPLOYEE: 200,
  SPOUSE: 210,
  CHILD: 220,
  ADULT_CHILD: 230,
  DOMESTIC_PARTNER: 240,
  CHILD_OF_DOMESTIC_PARTNER: 250,
} as const
export const PersonRelationshipSchemas = z.nativeEnum(PersonRelationshipEnum)
export type PersonRelationship = z.infer<typeof PersonRelationshipSchemas>

export const PersonRelationshipToContributionRelationship = {
  [PersonRelationshipEnum.EMPLOYEE]: ContributionRelationshipEnum.EMPLOYEE,
  [PersonRelationshipEnum.SPOUSE]: ContributionRelationshipEnum.SPOUSE,
  [PersonRelationshipEnum.CHILD]: ContributionRelationshipEnum.CHILD,
  [PersonRelationshipEnum.ADULT_CHILD]:
    ContributionRelationshipEnum.ADULT_CHILD,
  [PersonRelationshipEnum.DOMESTIC_PARTNER]:
    ContributionRelationshipEnum.DOMESTIC_PARTNER,
  [PersonRelationshipEnum.CHILD_OF_DOMESTIC_PARTNER]:
    ContributionRelationshipEnum.CHILD_OF_DOMESTIC_PARTNER,
} as const satisfies Record<PersonRelationship, ContributionRelationship>
